// src/constants/suggestedQuestions.js
//
// Questions are grounded in the data actually present on the SAP server
// (202.83.16.193:8001) as profiled on 2026-08-25. Concrete IDs used below are
// real: suppliers 100000/100005/100006/100007, POs 4500000000-4500000007,
// PRs 10000000-10000003, invoices 5105600751-5105600760, material documents
// 5000000000-5000000015, materials 2/11/22, plants TS01/TS02.

import { FINANCE_COMPANY } from './financeCompany';

const suggestedQuestions = {
    'Business Partner': {
      Customer: [
        "How many customers do we have?",
        "Show me the details of customer Greenfield Trading Pvt Ltd.",
        "List all customers with their customer number and full name."
      ],
      'Business Partner': [
        "How many business partners do we have?",
        "List all business partners with their number and full name.",
        "Which business partners were created by AKASH?"
      ],
      'Supplier': [
        "How many suppliers do we have?",
        "Show me the details of supplier Palmtop vegeoil.",
        "List all suppliers with their supplier number, name and account group."
      ]
    },
    'Sales Order': {
      'SalesOrder': [
        "How many sales orders do we have?",
        "List all sales orders with their sold-to party and net amount."
      ],
      'SalesOrderItem': [
        "How many sales order items do we have?",
        "List all sales order items with material, quantity and net value."
      ]
    },
    'Human Resource': {
      "All functions": [
        "List all employees in AI Department.",
        "any projects that still need to be billed.",
        "can you identify the employees who got burnout for working alot ."
      ],
      Timesheets: [
        "Show pending timesheet approvals.",
        "List all timesheet entries for last week.",
        "How many hours did Jane log?"
      ],
      'Leave Details': [
        "Show leave balance for all employees.",
        "Who is on leave this week?",
        "List recent leave requests."
      ]
    },
    'Cost Center':{
      'CostCenterMaster':[
        "How many cost centers do we have?",
        "List all cost centers in controlling area 0001.",
        "How many cost centers are there for each cost center category?"
      ],
      'GLAccountMaster':[
        "How many GL accounts do we have?",
        "Show me the details of GL account 11000.",
        "How many GL accounts are balance sheet accounts versus P&L accounts?"
      ]
    },
    'Material Document':{
      'MaterialDocument':[
        "How many material documents do we have?",
        "List all material documents created by ROHIT.",
        "Show material document 5000000015."
      ],
      'MaterialDocumentitem':[
        "List all material document items with material, plant and quantity.",
        "Show the total quantity received for each material.",
        "Which material document items reference purchase order 4500000005?"
      ],
    },
    'Inventory':{
      'MaterialDocumentHeader':[
        "How many material documents do we have?",
        "How many material documents were created by AKASH?",
        "Show material document 5000000012."
      ],
      'MaterialDocumentitem':[
        "List all goods movements with movement type 101.",
        "What materials were moved in plant TS01?",
        "Show the total quantity received per storage location."
      ],
      'Material_stock_information':[
        "What is the stock of material 22 in plant TS01?",
        "List all materials with their stock quantity by plant.",
        "Which materials currently have zero stock?"
      ],
      'PhysicalInventoryDocumentHeader':[
        "How many physical inventory documents do we have?",
        "Show all physical inventory documents."
      ],
      'PhysicalInventoryDocumentItem':[
        "List all physical inventory items with their counted quantity.",
        "Show physical inventory items for plant TS01."
      ]
    },
    'Purchase Orders':{
      'PurchaseOrder':[
        "How many purchase orders do we have?",
        "Show me purchase order 4500000003.",
        "List all purchase orders with their supplier, currency and created by user."
      ],
      'PurchaseOrderItem':[
        "What material is on purchase order 4500000005?",
        "List all purchase order line items with material, plant, quantity and net price.",
        "Which purchase order items are not yet completely delivered?"
      ],
      'PurchaseOrderScheduleLines':[
        "What is the delivery schedule date for purchase order 4500000004?",
        "List all purchase order schedule lines with their delivery dates and quantities.",
        "Show the total scheduled quantity per purchase order."
      ],
      'PurchaseOrderPricing':[
        "How many pricing conditions do we have?",
        "Show all pricing conditions with their condition type, rate and amount."
      ],
    },
    'Purchase Requisition':{
      'PurchaseRequisitionItem':[
        "Show purchase requisition 10000000.",
        "List all purchase requisitions with material, plant, quantity and price.",
        "How many purchase requisitions are for plant TS02?"
      ],
      'PurchaseRequisitionHeader':[
        "How many purchase requisitions do we have?",
        "List all purchase requisitions with their requisition type.",
        "Show purchase requisition 10000003."
      ]
    },
    // Vendor questions are restricted to fields that are actually populated on
    // this system (profiled 2026-08-27, 8 vendors: 100000, 100005-100011).
    // Country, Region, Language, VAT and all TaxNumber fields are empty on every
    // row, so nothing here asks for them.
    'Vendor':{
      'VendorMaster':[
        "How many vendors do we have?",
        "List all vendors with their vendor number, name and city.",
        "Show me the full address of vendor Steel Traders."
      ],
      'Supplier':[
        "Which vendors are blocked for purchasing or payment?",
        "Which vendors were created by AKASH?",
        "List all vendors with their account group and creation date."
      ]
    },
    'Goods Movement':{
      'GRN':[
        "How many goods receipts do we have?",
        "List all goods receipts with their purchase order, material and quantity.",
        "Show the total quantity received per purchase order."
      ],
      'MaterialDocumentHeader':[
        "List all material documents with their posting date and who created them.",
        "How many goods receipts were posted in each month?",
        "Show material document 5000000015 with its document and posting date."
      ]
    },
    'Policy Repository':{
      'Documents':['Will my family be covered under my insurance?',
        'What all documents will I need for reimbursement?',
        "What is the process for submitting a claim?",
      ]
    },
    // Finance Reports covers one company at a time (FINANCE_COMPANY).
    // Taurani: audited group accounts of THL (UK) Holdings, the UK & Ireland
    // arm, FY2021-FY2025 (years to 30 June), with full notes.
    'Analytics': FINANCE_COMPANY === 'taurani' ? {
      'Finance Reports':[
        "Why did the UK business swing from a GBP 15.6 million profit in FY2022 to losses in FY2024 and FY2025?",
        "How much of the group loss comes from Parkersteel, and what would the UK results look like without it?",
        "How dependent is the UK business on the Taurani group for supply and funding? Quantify it.",
        "Turnover fell from GBP 189 million to GBP 137 million but overheads barely moved. Where should we cut costs?",
        "Assess liquidity at 30 June 2025: cash, invoice discounting, group loans and the HMRC duty claim.",
        "What do stock days and debtor days tell us about working-capital discipline over five years?"
      ]
    } :
    // PETRONAS: six public Group results documents, FY2022-FY2025 plus 1H 2026,
    // with P&L, balance sheet, cash flow, segments and operating volumes.
    FINANCE_COMPANY === 'petronas' ? {
      'Finance Reports':[
        "How did revenue, EBITDA and PAT move from FY2022 to FY2025, and how much of the decline is price, volume and foreign exchange?",
        "1H 2026 PAT rose only MYR 1.0 billion despite 15% higher revenue. Walk me through the PRefChem loss recognition and the upstream divestment gains.",
        "Is the dividend to the Government sustainable? Compare free cash flow with dividends paid from FY2022 to 1H 2026.",
        "Which segment creates the most value? Compare Upstream, Gas & Maritime, Downstream and Corporate on revenue, PAT and capital investments.",
        "Assess our balance sheet strength at 30 June 2026: gearing, net cash, borrowings and the dividend payable.",
        "What is LNG Canada doing to our LNG volumes and Gas & Maritime profit in 1H 2026?"
      ]
    } : {
      // Sattva fallback - the Financial Analyst reads two Sattva Developers PDFs: a FY2025
      // limited-review extract (FY25 vs FY24) and consolidated statements for
      // FY2024/FY2023/FY2022. That gives a four-year series on the balance sheet
      // and the P&L only - there is no cash flow statement, no notes, no segment
      // or related-party disclosure, so nothing here asks for them.
      'Finance Reports':[
        "What is the revenue and profit CAGR from FY2022 to FY2025? Show me the calculations and tell me how reliable those growth rates are.",
        "Track our EBITDA margin from FY2022 to FY2025 and tell me whether operational efficiency has improved, stayed flat or declined.",
        "How much of FY2025 profit comes from core operations versus other income and share of profit from associates and joint ventures? What does that say about earnings quality?",
        "Cost of stores material sold jumped from 15.48 in FY2024 to 3,952.69 in FY2025. Walk me through what that did to our cost structure and margins.",
        "Assess our leverage and liquidity at 31 March 2025: debt to equity, current ratio, and the shift of borrowings into the current portion.",
        "Inventories rose to 10,007.52 and trade receivables to 1,230.81 in FY2025. What does the working capital build tell you, and what should I be watching?"
      ]
    },
    // Finance Analyst answers the same company's statements in chat, and draws
    // a chart when the answer compares numbers.
    'Finance Analyst': FINANCE_COMPANY === 'taurani' ? {
      'Finance Analyst':[
        "Show turnover and gross profit from FY2021 to FY2025 as a graph.",
        "Chart profit after tax by year.",
        "How have net assets moved over the five years?",
        "How much did Parkersteel lose in FY2025 and FY2024?",
        "Compare related-party loans, related-party creditors and invoice discounting at 30 June 2025 in a bar chart.",
        "What was the auditor's opinion on the FY2025 accounts?"
      ]
    } : FINANCE_COMPANY === 'petronas' ? {
      'Finance Analyst':[
        "Show revenue, EBITDA and PAT from FY2022 to FY2025 as a graph.",
        "Chart PAT by segment for FY2025.",
        "How did free cash flow compare with dividends paid each year?",
        "What was gearing at 30 June 2026?",
        "Plot capital investments by year.",
        "What drove the change in 1H 2026 PAT?"
      ]
    } : {
      'Finance Analyst':[
        "Show revenue and profit from FY2022 to FY2025 as a graph.",
        "Chart the EBITDA margin by year.",
        "What was the debt to equity ratio at 31 March 2025?",
        "Compare inventories and trade receivables across the years in a bar chart.",
        "How much other income did we report in FY2025?",
        "What is the current ratio at 31 March 2025?"
      ]
    },
    'Vendor Invoice':{
      'VendorInvoice':[
        "How many vendor invoices do we have in company code 1000?",
        "Show me invoice 5105600751.",
        "Show the total invoice gross amount for each invoicing party."
      ],
      'VendorInvoiceItem':[
        "List all invoice items with their purchase order and amount.",
        "Which invoice items reference goods receipt 5000000015?",
        "Show the total invoiced amount per purchase order."
      ],
      'direct_post':[
        "List all accounting documents with their posting key and document type.",
        "How many documents do we have for each posting key?"
      ],
    },
    'Vendor Ledger':{
      'accounting':[
        "How many open items do we have for vendor 100000?",
        "List all vendor line items that are not yet cleared.",
        "Show the total outstanding amount per vendor."
      ]
    },
    'Palmtop':{
      'master_plan':[
        "How many shipments are scheduled for AUGUST - 2025?",
        "List all items for customer PUNJAS & SONS (OILS) LTD with their batch number and total quantity.",
        "Show the total quantity shipped to each final destination.",
        "Which items have an expiry date before 2027-01-01?"
      ]
    }

  };

  export default suggestedQuestions;
